import { getViewFromServiceType } from "@/utils/staffingUtil";

export interface FieldError {
  serviceType?: string;
  clientId?: string;
  staffUser?: string;
  clientService?: string;
  language?: string;
  clientSchedule?: string;
}

export function getClientInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2);
  const first = parts[0];
  const last = parts[parts.length - 1];
  return (
    first.charAt(0).toUpperCase() +
    first.charAt(1).toLowerCase() +
    last.charAt(0).toUpperCase() +
    last.charAt(1).toLowerCase()
  );
}

export function getPostingServiceType(role: string): string {
  switch (getViewFromServiceType(role)) {
    case "analyst":
      return "Analyst";
    case "assistant_rbt":
      return "Assistant";
    case "assessment":
      return "Assessment";
    default:
      return "Assistant";
  }
}
